




























import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import SetGeoFenceTimeFrameTrigger from './SetGeoFenceTimeFrameTrigger.coffee'

settings =
  name: 'SetGeoFenceTimeFrameTriggerModal'

  vue:
    props: ['resourceComponent', 'resourceKey']
    components: { Modal, RequestButton }
    mixins: [SetGeoFenceTimeFrameTrigger.trigger()]

export default VueOptions.vue settings
